import React from 'react';
import {Container} from "react-bootstrap";

import {useCheckAuth} from "../../../Hooks/RouteHooks";

import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from '../../Common/StreamBankPageHeader';
import {QueryToolTable, QueryToolTableFilter, QueryToolTableTitle} from './Table';

export const QueryToolIndexPage = props => {
    useCheckAuth();
    useContextIndependentPage();

    const classNames = useClassNames('sb-query-tool-index-page');

    const title = 'Query';

    return <Container className={classNames}>
        <StreamBankPageHeader
            Title={title}
        />
        <QueryToolTable
            FilterComponent={QueryToolTableFilter}
            Title={QueryToolTableTitle}
        />
    </Container>;
};